import ImagesSlider from './component'

export default ImagesSlider
